/**
 * 路径小工具 —— 单独成文件是为了**体积**:index.ts(随首屏加载)只需要这两个函数,
 * 不能为它把 scrub.ts 整份(噪音清单、脱敏正则)拖进首屏;scrub.ts 只随 sentryClient 懒加载。
 */

/** URL / path 去 query 和 hash:query 里常带业务参数(关键词、票据 ticket、手机号)。 */
export function stripQuery(url: string): string {
  const cut = url.search(/[?#]/);
  return cut < 0 ? url : url.slice(0, cut);
}

/**
 * API 路径归一,用作 GlitchTip 分组指纹和 tag:去 query,把数字 / 长 hex / uuid 段换成 `{id}`。
 * 不归一的话 `/tasks/123` 和 `/tasks/124` 会被拆成两个 issue。
 */
export function normalizeApiPath(path: string): string {
  return stripQuery(path)
    .split("/")
    .map((seg) =>
      /^\d+$/.test(seg) ||
      /^[0-9a-f]{16,}$/i.test(seg) ||
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(seg) ||
      /^[A-Z]-[0-9A-F]{6,}$/.test(seg)
        ? "{id}"
        : seg
    )
    .join("/");
}
